import { gql } from '@apollo/client';

export const GENERATE_BAT_REPORT = gql`
  query GenerateBatReport($cId: ID!, $pId: ID!) {
    generateBatReport(cId: $cId, pId: $pId) {
      base64
      fileName
      mimeType
    }
  }
`;